export default "__VITE_ASSET__X15d_MS___"